/**
 *
 * Various utility methods, usage via import
 *
 * ( ie. import { rotate } from "./util.js" )
 */


/**
 * toggle document scroll On / Off
 *
 * @param state toggle state
 */
export function toggleScroll(state) {
    if(state) {
        $("html").css({
            "overflow-y": "",
        });
        $("body").css({
            "overflow-y": "",
        });
    } else {
        $("html").css({
            "overflow-y": "hidden",
        });
        /*        $("body").css({
                    "overflow-y": "scroll"
                });*/
    }
}

/**
 * Prevent default event propagation on given event object
 * @param ev
 */
export function stopDefault(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
}

/**
 * Standard math clamp function
 *
 * @param val
 * @param min
 * @param max
 * @returns {number}
 */
export function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
}

/**
 * Apply a rotate animation on a given element
 *
 * @param selector Element selector
 * @param rotAngle Angle to rotate to (default 360 deg)
 * @param duration Speed / duration of animation (default 300ms)
 * @param relative Animate relative to current rotation
 */
export function rotate(selector, rotAngle = 360, duration = 300, relative = false) {
    const $elem = $(selector);
    let initial = 0;
    let rot = rotAngle;

    if(relative) {
        const css = $elem.css("transform");
        const values = css.split( '(' )[1].split(')' )[0].split(',');
        const angle = Math.round(Math.atan2(values[1],values[0]) * (180/Math.PI));
        const parsedAngle = (angle < 0 ? angle + 360 : angle);

        initial = parsedAngle;
        rot = initial + rotAngle;
    }

    $( {deg: initial} ).animate({deg: rot}, {
        duration: duration,
        step: function(now) {
            $elem.css({
                transform: "rotate(" + now + "deg)",
            });
        },
    });
}

/**
 * Check if browser is IE10 / IE11, checking feature detection
 */
export function isIE() {
     return /*@cc_on!@*/false || !!document.documentMode;
}

/**
 * Check if browser is IE10 / IE11, checking browser UserAgent
 * Note that browser detection via UA string is considered unreliable
 */
export function isIEUserAgent() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    // eslint-disable-next-line no-useless-escape
    return (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
}

/**
 * Check whether selected element is a specified percentage above the screen's bottom edge (above the fold)
 *
 * @param $elem JQuery object representation of target element
 * @param decimalPercentage percentage above screen edge (in decimal)
 *
 *
 * */
export function elementInPosition($elem, decimalPercentage) {
    if( !$elem.is(":visible") ) {
        return false;
    }
    const elemPos = $elem.offset().top;
    const windowBottom = $(window).scrollTop() + ( $(window).height() * decimalPercentage );
    return elemPos <= windowBottom;
}

/**
 * iframe elements do not handle click events; provide a workaround method to respond on window blur event
 * which indicates iframe
 *
 * @param callback
 */
export function iframeOnClick(selector, callback) {
    const $window = $(window);

    $window.focus();
    $(document).click();
    $window.on("blur", () => {
        const activeElem = document.activeElement;
        if( activeElem.nodeName === "IFRAME" && document.querySelector(selector).isSameNode(activeElem)) {
            callback();
        }
    });
}
